import React from 'react';
import ServiceFacility from 'views/EMR/Settings/BillingConfigurations/ServiceFacility';
import RenderingProvider from 'views/EMR/Settings/BillingConfigurations/RenderingProvider';
import BillingProvider from 'views/EMR/Settings/BillingConfigurations/BillingProvider';
import BillingProviderRules from 'views/EMR/Settings/BillingConfigurations/BillingProviderRules';

export const commonTableClasses = {
  scrollContainer: '!pb-0',
  cell: '!items-end',
  row: '!p-2',
  root: '!pb-0',
  outerRow: 'last:!border-b-0',
  header: '!items-end !px-2',
  scrollbarGutter: 'inherit',
  windowsClassName: '!w-full',
};

export default function BillingConfigurations() {
  return (
    <div className="h-full w-full overflow-hidden" style={{ contain: 'size' }}>
      <div className="h-full w-full px-4 pb-4 flex flex-col gap-4 overflow-y-auto">
        <ServiceFacility />
        <RenderingProvider />
        <BillingProvider />
        <BillingProviderRules />
      </div>
    </div>
  );
}
